export default __webpack_public_path__ + "static/media/Highlord's Staff.cceac3ac.jpg";